export default __webpack_public_path__ + "static/logo-RQD-b23f1c7abbf67f2b3fc2eb947de9fe2d.png";